/** @format */

import {createContext} from 'react'
const ProjectsContext=createContext([])
export const ProjectsProvider=ProjectsContext.Provider
export default ProjectsContext
